// src/pages/user/Dashboard.js
import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { FiUser, FiShoppingBag, FiHeart, FiSettings, FiGift, FiMail, FiShare2, FiLifeBuoy } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/api';

import Profile from './Profile';
import Orders from './Orders';
import Vouchers from './Vouchers';
import Favorites from './Favorites';
import MyRewards from './MyRewards';
import Referrals from './Referrals';
import Tickets from './Tickets';

const Dashboard = () => {
  const location = useLocation();
  const { user } = useAuth() || {};
  const [resending, setResending] = React.useState(false);
  const resendVerif = async () => {
    setResending(true);
    try {
      const r = await authAPI.resendVerification();
      toast.success(r?.data?.message || 'Email renvoyé. Vérifiez votre boîte mail.');
    } catch (e) {
      toast.error(e?.response?.data?.message || "Erreur lors de l'envoi");
    } finally { setResending(false); }
  };

  const menuItems = [
    { path: '/dashboard', label: 'Mon profil', icon: FiUser },
    { path: '/dashboard/orders', label: 'Mes commandes', icon: FiShoppingBag },
    { path: '/dashboard/vouchers', label: 'Mes vouchers', icon: FiSettings },
    { path: '/dashboard/rewards', label: 'Mes récompenses', icon: FiGift },
    { path: '/dashboard/referrals', label: 'Parrainage', icon: FiShare2 },
    { path: '/dashboard/favorites', label: 'Mes favoris', icon: FiHeart },
    { path: '/dashboard/tickets', label: 'Support', icon: FiLifeBuoy }
  ];

  // Fonction d’activation robuste
  const isMenuActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-8">Mon Compte</h1>

      {/* P0-B : bannière DOUCE (non bloquante) si l'email n'est pas vérifié.
          TODO : une restriction d'accès pourra être ajoutée ici plus tard. */}
      {user && user.emailVerified === false && (
        <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
          <span className="flex items-center gap-2 text-amber-800 text-sm flex-1">
            <FiMail size={16} className="flex-shrink-0" />
            Votre adresse e-mail n'est pas encore vérifiée. Confirmez-la pour sécuriser votre compte.
          </span>
          <button type="button" disabled={resending} onClick={resendVerif}
            className="px-4 py-1.5 rounded-lg bg-amber-600 text-white text-sm font-semibold hover:bg-amber-700 disabled:opacity-50 whitespace-nowrap">
            {resending ? 'Envoi...' : "Renvoyer l'email de vérification"}
          </button>
        </div>
      )}


      <div className="grid md:grid-cols-4 gap-6">
        
        {/* Menu latéral */}
        <div className="md:col-span-1">
          <div className="bg-white rounded-lg shadow p-4">
            <nav className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const active = isMenuActive(item.path);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                      active
                        ? 'bg-primary-50 text-primary-600 font-semibold shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50 hover:shadow-sm'
                    }`}
                  >
                    <Icon size={20} />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Contenu */}
        <div className="md:col-span-3">
          <div className="bg-white rounded-lg shadow p-6">
            <Routes>
              <Route index element={<Profile />} />
              <Route path="orders" element={<Orders />} />
              <Route path="vouchers" element={<Vouchers />} />
              <Route path="rewards" element={<MyRewards />} />
              <Route path="referrals" element={<Referrals />} />
              <Route path="favorites" element={<Favorites />} />
              <Route path="tickets" element={<Tickets />} />
            </Routes>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
